<template>
  <v-container fluid class="rtl">
    <v-card v-if="canView" class="ma-2 white rounded-lg">
      <v-card-title class="secondary--text">گزارش ارسال‌های مودیان</v-card-title>
      <v-card-subtitle>برای بررسی وضعیت ارسال، پاسخ سرویس‌دهنده و خطاهای ثبت‌شده</v-card-subtitle>
      <v-card-text>
        <m-datatable
          :headers="headers"
          :apiUrl="listUrl"
          :filters.sync="filters"
          :show-select="false"
          :show-filter-row="false"
          @detail="openDetail"
          ref="datatable"
        >
          <template #item.status="{ item }">
            <v-chip small :color="statusColor(item.status)" dark>{{ display(item.status) }}</v-chip>
          </template>
          <template #item.provider="{ item }">{{ display(item.provider || item.provider_name) }}</template>
          <template #item.detail="{ item }">
            <v-btn icon color="info" @click="openDetail(item)" title="مشاهده جزئیات">
              <v-icon>fa-info</v-icon>
            </v-btn>
          </template>
        </m-datatable>
      </v-card-text>
    </v-card>
    <v-card v-else class="ma-2 pa-6 text-center">شما مجوز مشاهده این گزارش را ندارید.</v-card>

    <v-dialog v-model="detailDialog" max-width="900px" scrollable>
      <v-card>
        <v-card-title class="secondary--text">جزئیات ارسال مودیان</v-card-title>
        <v-card-text v-if="detailLoading" class="text-center pa-8"><v-progress-circular indeterminate color="primary" /></v-card-text>
        <v-card-text v-else-if="selectedSubmission">
          <v-row dense>
            <v-col v-for="field in summaryFields" :key="field.key" cols="12" sm="6" md="4">
              <div class="caption grey--text text--darken-1">{{ field.label }}</div>
              <div class="body-2 text-break">{{ formatValue(selectedSubmission[field.key]) }}</div>
            </v-col>
          </v-row>
          <v-divider class="my-4" />
          <div v-for="field in detailFields" :key="field.key" class="mb-4">
            <div class="subtitle-2 font-weight-bold mb-1">{{ field.label }}</div>
            <pre class="detail-json">{{ formatValue(selectedSubmission[field.key], true) }}</pre>
          </div>
        </v-card-text>
        <v-card-text v-else class="text-center pa-8">جزئیاتی برای نمایش وجود ندارد.</v-card-text>
        <v-card-actions><v-spacer /><v-btn text @click="detailDialog = false">بستن</v-btn></v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
export default {
  name: "MoadianSubmissions",
  data() {
    return {
      listUrl: "sobhanAdmin/moadian-submissions/",
      filters: {},
      detailDialog: false,
      detailLoading: false,
      selectedSubmission: null,
      headers: [
        { text: "شناسه", value: "id" },
        { text: "وضعیت", value: "status" },
        { text: "سرویس‌دهنده", value: "provider" },
        { text: "شناسه رهگیری", value: "tracking_id" },
        { text: "شناسه یکتا", value: "unique_id" },
        { text: "شماره مالیاتی", value: "tax_serial_number" },
        { text: "تاریخ ایجاد", value: "created_at", type: "datetime" },
        { text: "آخرین به‌روزرسانی", value: "updated_at", type: "datetime" },
        { text: "جزئیات", value: "detail", sortable: false, filterable: false },
      ],
      summaryFields: [
        { key: "id", label: "شناسه" }, { key: "status", label: "وضعیت" },
        { key: "provider", label: "سرویس‌دهنده" }, { key: "tracking_id", label: "شناسه رهگیری" },
        { key: "unique_id", label: "شناسه یکتا" }, { key: "tax_serial_number", label: "شماره مالیاتی" },
        { key: "created_at", label: "تاریخ ایجاد" }, { key: "updated_at", label: "آخرین به‌روزرسانی" },
        { key: "submitted_at", label: "زمان ارسال" },
      ],
      detailFields: [
        { key: "request", label: "درخواست" }, { key: "request_data", label: "داده درخواست" },
        { key: "response", label: "پاسخ" }, { key: "response_data", label: "داده پاسخ" },
        { key: "error_message", label: "پیام خطا" }, { key: "provider_message", label: "پیام سرویس‌دهنده" },
      ],
    };
  },
  computed: {
    canView() {
      return !!(this.user && (this.user.is_superuser || (this.user.permissions && this.user.permissions.moadian_submissions)));
    },
  },
  methods: {
    display(value) { return value === null || value === undefined || value === "" ? "—" : value; },
    statusColor(status) {
      const value = String(status || "").toLowerCase();
      if (value.includes("success") || value.includes("accepted") || value.includes("موفق")) return "success";
      if (value.includes("fail") || value.includes("error") || value.includes("خطا")) return "error";
      if (value.includes("pending") || value.includes("در انتظار")) return "warning";
      return "primary";
    },
    formatValue(value, json) {
      if (value === null || value === undefined || value === "") return "—";
      if (json && typeof value === "object") return JSON.stringify(value, null, 2);
      if (typeof value === "object") return JSON.stringify(value);
      return value;
    },
    openDetail(item) {
      if (!item || !item.id) return;
      this.detailDialog = true;
      this.detailLoading = true;
      this.selectedSubmission = null;
      this.request({
        url: this.endpoint(this.listUrl + item.id + "/"),
        method: "get",
        success: data => { this.selectedSubmission = data; this.detailLoading = false; },
        error: () => { this.detailLoading = false; },
      });
    },
  },
};
</script>

<style scoped>
.detail-json { background: #f5f5f5; border-radius: 4px; padding: 10px; white-space: pre-wrap; word-break: break-word; max-height: 260px; overflow: auto; direction: ltr; text-align: left; }
.text-break { word-break: break-word; }
</style>
